"use client";

import { PlayCircleOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import React, { useCallback, useState } from "react";
import FormGetAddress from "../../formGetAddress";
import AppModal from "../../appModal";

const BannerContent = () => {
  const { Title } = Typography;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  return (
    <>
      <div className="container relative z-[1000] pt-28 pb-13 sm:pt-32 sm:pb-15 md:pt-38 md:pb-16 mid:!pt-40 mid:!pb-20 lg:!pt-48 lg:!pb-24 2xl:!pt-58 2xl:!pb-36">
        <div className="flex gap-10 h-full flex-col w-full xs:max-w-[80%] sm:max-w-[70%]">
          <div>
            <button
              onClick={() => setIsModalOpen(true)}
              className="p-2 md:p-3 cursor-pointer mb-4 bg-regal-white-blur text-white rounded-md gap-1 flex items-center"
            >
              <PlayCircleOutlined />
              <Title level={5} className="H5 whiteColor-text">
                ما چیکار می کنیم؟
              </Title>
            </button>
            <div className="flex flex-col gap-1 md:gap-2">
              <Title level={1} className="H1 whiteColor-text">
                هر پرتو، یک درآمد، تا برق
              </Title>
              <p className="text-white w-full text-justify">
                با همراهی تابرق، آفتاب را به جریان بی‌پایان درآمدت تبدیل کن. برق
                مصرفیتو از انرژی پاک بگیر، قبض رو فراموش کن و مازادش رو به درآمد
                تبدیل کن. این فقط صرفه‌جویی نیست… این یعنی بازی رو عوض کردن!
              </p>
            </div>
          </div>
          <FormGetAddress formName="bannerForm" />
        </div>
      </div>
      <AppModal
        isModalOpen={isModalOpen}
        modalTitle="ما چیکار می کنیم؟"
        closeModal={closeModal}
      >
        <video
          controls
          className="w-full h-[70vh] object-contain rounded-md bg-black"
        >
          <source src="/video/movie.mp4" type="video/mp4" />
          <span className="text-white text-center block mt-4">
            مرورگر شما از ویدئو پشتیبانی نمی‌کند.
          </span>
        </video>
      </AppModal>
    </>
  );
};

export default BannerContent;
